import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartCondition,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}parts/searchbynamelocal`;

export interface SparePartSearchLightSummary {
  sparePartId: string;
  manufacturerReference?: string;
  manufacturerLabel?: string;
  manufacturerName?: string;
  manufacturerId: string;
  supplierName?: string;
  supplierPartReference?: string;
  condition: SparePartCondition;
  sparePartSupplierAssociationId: string;
}

export interface SearchSparePartsByNameLocalQueryArgs {
  sellerId?: string;
  searchTerm: string;
}

async function searchSparePartsByNameLocalQuery({
  sellerId,
  searchTerm,
}: SearchSparePartsByNameLocalQueryArgs): Promise<
  BackResponse<SparePartSearchLightSummary[]> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SparePartSearchLightSummary[]>>(
      buildUrl(ENDPOINT, {
        SellerId: sellerId,
        SearchTerm: searchTerm,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default searchSparePartsByNameLocalQuery;
